import { render, staticRenderFns } from "./RegPDFJSViewer.vue?vue&type=template&id=247d14cc&"
import script from "./RegPDFJSViewer.vue?vue&type=script&lang=js&"
export * from "./RegPDFJSViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports